<template>
  <div :id="$options.name">
    <a-restaurant-sales
      ref="a-restaurant-sales"
      :tab_view="tab_view"
    ></a-restaurant-sales>
  </div>
</template>

<script>
import aRestaurantSales from "@/components/restaurant/aRestaurantSales.vue";

export default {
  name: "restaurantSalesApp",
  components: {
    aRestaurantSales
  },
  props: {
    tab_view: {
      type: String,
      default: "resume"
    }
  }
};
</script>
